
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  UmbrellaIdentitySignupRequest,
  ValidationError,
} from '../models';
import {
    UmbrellaIdentitySignupRequestFromJSON,
    UmbrellaIdentitySignupRequestToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface CreateUmbrellaIdentityRequest {
    umbrellaIdentitySignupRequest: UmbrellaIdentitySignupRequest;
}

/**
 * 
 */
export class UmbrellaIdentityCreationApi extends runtime.BaseAPI {

    /**
     * Creates an umbrella identity and company
          */
    async createUmbrellaIdentityRaw(requestParameters: CreateUmbrellaIdentityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['umbrellaIdentitySignupRequest'] == null) {
            throw new runtime.RequiredError(
                'umbrellaIdentitySignupRequest',
                'Required parameter "umbrellaIdentitySignupRequest" was null or undefined when calling createUmbrellaIdentity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/compliance/api/umbrella/signup`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UmbrellaIdentitySignupRequestToJSON(requestParameters['umbrellaIdentitySignupRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Creates an umbrella identity and company
          */
    async createUmbrellaIdentity(requestParameters: CreateUmbrellaIdentityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.createUmbrellaIdentityRaw(requestParameters, initOverrides);
    }

}
